import React, { useEffect, useState } from "react";
import "./MessageCodes.css";

const MessageA1grey = (props) => {
    const [onSelect , setOnSelect] = useState(false)
    useEffect(()=>{
        props.setisSubscriber(false)
    })

    if (!props?.item?.text?.trim()) {
      return null;
    }
  

  return (
    <div className="a1-wrap cursor-not-allowed" style={{ width: "fit-content" , margin : '6px' }}>
      <div
        className={
          !onSelect
            ? "chat-label action-tab cursor-not-allowed  "
            : "chat-label-select action-tab cursor-not-allowed "
        }
        id="main-tab1"
        style={{ color: props.disable && "grey" , background : '#575757' ,cursor :'not-allowed' , pointerEvents : 'none' ,color :'white'}}
        onClick={() => {
          if (!props.disable) {
            // props.handleClick(props.item.code, null, props.item.text);
            // props.setTextOnClick(props.item.text);
        
            const data = JSON.parse(localStorage.getItem("inputValue"));
            let input
            if(data && props?.item?.text === 'Submit'){
            localStorage.removeItem("inputValue"); 
             input = data?.key1
             props?.addMessages(input,props?.item?.code , props?.item?.text )
             setOnSelect(true)
            // }else if (!data && props?.item?.text === 'Submit'){
            //   return
            // }else if (data  && (props?.item?.text === 'Yes' || props?.item?.text === 'No' )){
            //   localStorage.removeItem("inputValue"); 
            //   input = data?.key1
            //   props?.addMessages(input,props?.item?.code ,props?.item?.text ,input )
            //   setOnSelect(true)
            //   return
            }else{
              input =props?.item?.text
              const checkUpdate = props?.item?.data ? JSON.parse(props.item.data) : undefined;
              props?.addMessages(null ,props?.item?.code ,props?.item?.text  ,null, checkUpdate?.action)
              setOnSelect(true)
            }
            localStorage.removeItem("ignoreError");
            localStorage.removeItem("inputValue");
            localStorage.removeItem("troubleShooting");
            localStorage.removeItem("inputBoxValue");
            localStorage.removeItem("inputValue1");
          }
        }}
      >
        {props?.item?.text}
      </div>
    </div>
  );
};

export default MessageA1grey;
